import { render, staticRenderFns } from "./Vaults.vue?vue&type=template&id=041f91d6"
import script from "./Vaults.vue?vue&type=script&lang=js"
export * from "./Vaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports